import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface AgencyIssuedDocuments {
  name: string;
  api_token: string;
}

export interface AgencyIssuedDocumentsListInfor {
  errors: unknown;
  agencyIssuedDocuments: AgencyIssuedDocuments;
  isAuthenticated: boolean;
}

@Module
export default class AgencyIssuedDocumentsModule
  extends VuexModule
  implements AgencyIssuedDocumentsListInfor
{
  errors = {};
  agencyIssuedDocuments = {} as AgencyIssuedDocuments;
  isAuthenticated = !!JwtService.getToken();

  get AgencyIssuedDocuments() {
    return this.agencyIssuedDocumentsListData;
  }

  @Mutation
  [Mutations.AGENCY_ISSUED_DOCUMENTS_LIST_DATA](AgencyIssuedDocuments) {
    this.agencyIssuedDocumentsListData = AgencyIssuedDocuments;
  }

  @Action
  [Actions.AGENCY_ISSUED_DOCUMENTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/agency_issued_document", payload)
        .then((data) => {
          this.context.commit(
            Mutations.AGENCY_ISSUED_DOCUMENTS_LIST_DATA,
            data
          );
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.AGENCY_ISSUED_DOCUMENT_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("agency_issued_document/upsert", payload)
        .then((data) => {
          this.context.commit(
            Mutations.AGENCY_ISSUED_DOCUMENTS_LIST_DATA,
            data
          );
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.AGENCY_ISSUED_DOCUMENT_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/agency_issued_document",
        "upsert",
        id,
        payload
      )
        .then((data) => {
          this.context.commit(
            Mutations.AGENCY_ISSUED_DOCUMENTS_LIST_DATA,
            data
          );
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.AGENCY_ISSUED_DOCUMENT_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/agency_issued_document",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(
            Mutations.AGENCY_ISSUED_DOCUMENTS_LIST_DATA,
            data
          );
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
